import {Pipe, PipeTransform} from '@angular/core';
import {GeschaeftsnummerEntry} from "../../../core/gb-api";
import {KompaktAmtnummerPipe} from "../../kompaktdarstellung/amt/kompakt-amtnummer-pipe";

@Pipe({
  name: 'formatGeschaeftsnummer'
})
export class FormatGeschaeftsnummerPipe implements PipeTransform {
  private ANZAHL_STELLEN = 6;

  constructor(private kompaktamt: KompaktAmtnummerPipe) {
  }

  transform(geschaeftsnummer: GeschaeftsnummerEntry): any {
    if (!geschaeftsnummer) {
      return '';
    }
    return this.kompaktamt.transform(geschaeftsnummer.amtNummer).toString()
      + geschaeftsnummer.jahr
      + '/' + (geschaeftsnummer.nummer + Math.pow(10, this.ANZAHL_STELLEN) + "").slice(1)
      + (geschaeftsnummer.index != null ? '/' + geschaeftsnummer.index : "");
  }
}
